<template>
  <div>
    <div v-if="loading" style="margin-top: 2rem">
      <SkeletonDiv v-for="i in 3" :key="i" :height="70" style="margin-bottom:1rem"/>
      <SkeletonDiv style="width:180px" :height="47"/>
    </div>
    <template v-if="!loading">
      <ProductPackChild v-for="(product,i) in childrensData" :product="product" :index="i" v-on:variation-selected="updateSelection"/>
      <button type="button" @click="addToCart">Ajouter au panier</button>
    </template>
  </div>
</template>

<script>
import SkeletonDiv from "@/components/skeletons/SkeletonDiv";
import ProductPackChild from "@/front/components/product/ProductPackChild";

export default {
  name: "ProdutPackAddToCart",
  components: {ProductPackChild, SkeletonDiv},
  data() {
    return {
      loading: false,
      childrens: [],
      childrensData: [],
      selection: {},
    }
  },
  methods: {
    getChildsData() {
      this.loading = true
      this.$api.get('wc/v3/products', {
        params: {include: this.childrens, withAttributeSummaries: 1},
        auth: {
          username: 'ck_1a4505854ff29868e87378231d7faa1eb2028787',
          password: 'cs_2ff991b48fe64cc576d4c27dbe2bb4f7e4581261',
        }
      }).then(response => response.data)
        .then(data => this.childrensData = data)
        .finally(() => this.loading = false)
    },
    addToCart() {
      const href = `${window.location.href}?add-to-cart=${g2rObj.postId}&pack-children=${Object.keys(this.selection).join(',')}&pack-selection=${Object.values(this.selection).join(',')}`
      console.log(href)
      window.location.href = href
    },
    updateSelection(obj) {
      const childId = this.childrensData[obj.index].id
      this.selection[childId] = obj.id
    },
  },
  beforeMount() {
    this.childrens = JSON.parse(document.getElementById('pack-childrens').innerHTML)
  },
  mounted() {
    this.getChildsData()
  },
}
</script>

<style scoped lang="scss">

</style>
